export const black = '#000000';
export const white = '#ffffff';
export const ice = '#dfe6f0';
export const chambray = '#2e4487';
export const malibu = '#79b7ff';
export const gallery = '#f0f0f0';
export const cod = '#1a1a1a';
export const gull = '#9ba2b7';
export const intKlein = '#030c28';
export const sapphire = '#0d2880';
export const night = '#07184d';
